/* eslint-disable no-shadow */
enum SourceType {
  NC = 'new-colors',
  SY = 'shop-your-looks',
  HOMEPAGE = 'homepage',
  SHOPPING_BAG = 'shopping-bag',
  SI = 'save-for-later',
  CATEGORIES = 'categories',
  UNGATED = 'ungated_shop',
}

export default SourceType;
